import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons';

interface MapButtonProps {
  onClick: () => void;
}

const MapButton = ({ onClick }: MapButtonProps) => {
  return (
    <div
      className="flex items-center justify-center rounded-full bg-sky-50 text-sky-600 w-16 h-8 gap-1.5 cursor-pointer"
      onClick={onClick}
    >
      <Icon icon={faLocationDot} className="text-sky-900 text-xs" />
      <p className="text-sky-900 text-xs font-bold">Map</p>
    </div>
  );
};

export default MapButton;
